'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
const StyledHelpText = styled(UILink).withConfig({
  displayName: "HelpText__StyledHelpText",
  componentId: "m9b3en-0"
})(["padding-top:14px;"]);

const HelpText = () => {
  return /*#__PURE__*/_jsx(StyledHelpText, {
    external: true,
    href: "https://knowledge.hubspot.com/resources/what-should-i-do-if-hubspot-videos-are-not-playing",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-addon-video-player.havingTroubleWithVideoLink"
    })
  });
};

export default HelpText;